export default "__VITE_ASSET__DaYFMutK__"